import type { ToyotaLeadCenterPayload } from "@/pages/api/toyota-lead-center";

function getDealerGroup(): string {
	return process.env.NEXT_PUBLIC_SITE_NAME?.toUpperCase() || "OSAKA";
}

export async function sendToToyotaLeadCenter(
	payload: Omit<ToyotaLeadCenterPayload, "dealer_group"> & {
		dealer_group?: string;
	}
): Promise<boolean> {
	try {
		const fullPayload: ToyotaLeadCenterPayload = {
			...payload,
			dealer_group: payload.dealer_group ?? getDealerGroup(),
			brand: payload.brand ?? "TOYOTA",
			isChat: payload.isChat ?? false,
		};

		const response = await fetch("/api/toyota-lead-center", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(fullPayload),
		});

		if (!response.ok) {
			console.warn("[sendToToyotaLeadCenter] Erro:", response.status);
			return false;
		}
		return true;
	} catch (error) {
		console.warn("[sendToToyotaLeadCenter] Erro:", error);
		return false;
	}
}

export async function sendToToyotaLeadCenterServer(
	payload: ToyotaLeadCenterPayload
): Promise<boolean> {
	try {
		const backendUrl =
			process.env.BACKEND_API_URL || "http://localhost:3001";
		const apiKey =
			process.env.API_KEY || process.env.NEXT_PUBLIC_API_KEY || "";

		if (!apiKey) return false;

		const fullPayload: ToyotaLeadCenterPayload = {
			...payload,
			dealer_group:
				payload.dealer_group ||
				process.env.NEXT_PUBLIC_SITE_NAME?.toUpperCase() ||
				"OSAKA",
		};

		const response = await fetch(
			`${backendUrl}/api/post-data/toyota-lead-center`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"x-api-key": apiKey,
				},
				body: JSON.stringify(fullPayload),
			}
		);

		if (!response.ok) {
			console.warn(
				"[sendToToyotaLeadCenterServer] Erro:",
				response.status
			);
			return false;
		}
		return true;
	} catch (error) {
		console.warn("[sendToToyotaLeadCenterServer] Erro:", error);
		return false;
	}
}